import { Tabs, TabPanels, TabPanel, TabList, Tab } from "@chakra-ui/tabs";
import { MdAlarm, MdOfflineBolt } from "react-icons/md";
import { t } from "i18next";

import AdhocReports from "./adhoc/page";
import { CONST } from "models/constants";
import { usePermissions } from "hooks/usePermissions";
import ScheduleReportsView from "./schedule/page";

const Reports = () => {
  const { canShow } = usePermissions();

  return (
    <Tabs variant="plain" isLazy>
      <TabList className="rounded-lg bg-gray-300 p-2">
        <Tab className="min-w-36 gap-1 rounded-lg p-1 text-primary aria-selected:bg-background-50 aria-selected:text-white">
          <MdOfflineBolt />
          {t("reports.tabs.generated")}
        </Tab>
        {canShow(CONST.ROLE_MANAGER) && (
          <Tab className="min-w-36 gap-1 rounded-lg p-1 text-primary aria-selected:bg-background-50 aria-selected:text-white">
            <MdAlarm />
            {t("reports.tabs.scheduled")}
          </Tab>
        )}
      </TabList>
      <TabPanels>
        <TabPanel>
          <AdhocReports />
        </TabPanel>
        {canShow(CONST.ROLE_MANAGER) && (
          <TabPanel>
            <ScheduleReportsView />
          </TabPanel>
        )}
      </TabPanels>
    </Tabs>
  );
};

export default Reports;
